/* eslint-disable react/jsx-filename-extension, react/require-default-props */
// Wrapper around SUI Dropdown that
//   1. Renders either a 'basic' or search-in-menu dropdown
//   2. Adds spacing shortcut props
//
import PropTypes from 'prop-types'
import SearchInMenu from './SearchInMenu'
import Basic from './Basic'

const Dropdown = ({
  searchInMenu = false,
  showSelectedIndicator = true,
  ...rest
}) => {
  if (!searchInMenu)
    return <Basic {...rest} showSelectedIndicator={showSelectedIndicator} />

  return (
    <SearchInMenu {...rest} showSelectedIndicator={showSelectedIndicator} />
  )
}

Dropdown.propTypes = {
  /* Option arrow color */
  arrowColor: PropTypes.string,

  // Callback when DD is blurred
  onBlur: PropTypes.func,

  // Callback when DD is closed.
  onClose: PropTypes.func,

  // Shows a search-in-menu with Groove's custom SearchBox/Divider
  searchInMenu: PropTypes.bool,

  // Shows the return icon next to the active option
  showSelectedIndicator: PropTypes.bool,

  // The rest are per SUI Dropdown...
}

Dropdown.displayName = 'Dropdown'

export default Dropdown
